function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke-miterlimit:10;stroke-width:0.9px;}"));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M287.74,283.7H276.85a1.51,1.51,0,0,0-1.51,1.5v12.36a1.51,1.51,0,0,0,1.51,1.5H289.2a1.51,1.51,0,0,0,1.51-1.5v-11",
  transform: "translate(-274.89 -278.61)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M295.16,279.55l-.33-.33a.53.53,0,0,0-.75,0l-10,10-.2,1.12a.14.14,0,0,0,.16.17l1.12-.21,10-10A.53.53,0,0,0,295.16,279.55Z",
  transform: "translate(-274.89 -278.61)"
});
function SvgAddOneToOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.87 20.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOneToOne);
export default __webpack_public_path__ + "static/media/AddOneToOne.fc085260.svg";
export { ForwardRef as ReactComponent };